<div *ngIf="checkViewMode('edit')" class="form-group switch-group">
  <label for="">
    {{attribute.key}}
    <span class="error-indication" *ngIf="true">*</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" 
    [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <div class="row">
    <div class="col-md-2">
      <ui-switch [checked]="isCheched" [disabled]="disabled ? true : false"  (valueChange)="onValueChange($event)"></ui-switch>
    </div>
    <div class="col-md-10">
      <ng-select *ngIf="isCheched"
        [id]="getOptionByKey(attribute,'identifier')"
        [items]="Items"
        (change)=ngChangedSelect()
        [hideSelected]="true"
        multiple="true"
        bindLabel="Value"
        [placeholder]="getOptionByKey(attribute,'placeholder')" [(ngModel)]="SelectedItems"
        [disabled]="!isCheched"
        [required]="getOptionByKey(attribute,'required')" >
      </ng-select>
    </div>
  </div>
</div>


<div class="m-switch-text-view" *ngIf="checkViewMode('view') && attribute.value!=''&&attribute.value!= null">
    <div class="m-switch-text-view-container">
      <label> {{getOptionByKey(attribute,'hideTitle')== 'true'? '' : attribute.key}} </label>
      <p> {{attribute.value}}</p>
    </div>
</div>
<div class="m-switch-text-view" *ngIf="checkViewMode('view') && (attribute.value==''||attribute.value== null)">
    <div class="m-switch-text-view-container">
        <label> {{getOptionByKey(attribute,'hideTitle')== 'true'? '' : attribute.key}} </label>
        <p> {{textNotChecked}}</p>
      </div>

</div>
